<template>
  <div class="payment-summary">
    <div class="payment-summary__header">
      <h3 class="payment-summary__header--title">
        {{ title }}
      </h3>
      <span class="payment-summary__header--subtitle">We will email you to confirm your first payment date and frequency.<br> You will also receive a copy of The Foundation Agreement upon completion.</span>
    </div>

    <StepContent :theme="theme">
      <div class="payment-summary-content">
        <PlanSelectionCardReadOnly
          class="min-w-340 max-w-340"
          :theme="theme"
        />
      </div>
      <div class="text-center mt-10">
        <span class="opacity-30">
          *Payment Amounts may vary slightly.
        </span>
      </div>
    </StepContent>

    <StepFooter
      hide-mobile
      split
    >
      <div class="text-center">
        <AppButton
          :theme="theme"
          :loading="submitting"
          class="payment-summary__button"
          @click="handleContinue"
        >
          Finish
        </AppButton>

        <br>

        <AppLink
          class="mr-10"
          icon="chevron-left"
          icon-position="left"
          :theme="theme"
          :to="backPath"
        >
          Back
        </AppLink>
      </div>
    </StepFooter>

    <AppFAQ
      :theme="theme"
      :questions="faqList"
      class="payment-summary__faq"
    />
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppLink from '@/components/common/buttons/AppLink'
import AppFAQ from '@/components/common/faq/AppFAQ'
import StepContent from '@/components/common/step-layout/StepContent'
import submitLoans from '@/mixins/submit/submit-loans'
import StepFooter from '@/components/common/step-layout/StepFooter'
import navigation from '@/mixins/navigation'
import theme from '@/mixins/theme'
import PlanSelectionCardReadOnly from '@/components/common/cards/PlanSelectionCardReadOnly'

export default {
  name: 'PaymentSummary',

  components: {
    StepContent,
    StepFooter,
    AppButton,
    AppLink,
    AppFAQ,
    PlanSelectionCardReadOnly
  },

  mixins: [
    submitLoans,
    navigation,
    theme
  ],

  props: {
    faq: {
      type: Array,
      default: () => []
    },
    foundationBloomFAQ: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      title: 'This Is What You’re Signing Up For',
      info: 'You will receive a copy of The Foundation Agreement upon completion.'
    }
  },

  computed: {
    backPath () {
      return this.$_navigation_backPath
    },

    foundationCardTitle () {
      return this.isFoundationGold ? 'The Foundation Gold' : 'The Foundation Basic'
    },

    isFoundationGold () {
      return this.$store.state.foundation.isFoundationGold
    },

    isBloomFlow () {
      return this.$store.state.foundation.isBloomFlow
    },
    isFollowUpFlow () {
      return this.$route.fullPath.includes('access_id')
    },

    dataLayerObject () {
      return {
        event: `spring_${this.eventPrefix}_complete`
      }
    },

    updateLeadPayload () {
      return {
        Agreement_Accepted__c: true,
        OPT_IN__c: this.isFoundationGold,
        pl_decline_follow_up: this.isFollowUpFlow
      }
    },

    faqList () {
      return this.isBloomFlow ? this.foundationBloomFAQ : this.faq
    }
  },

  watch: {
    $_navigation_triggerContinue: function (val) {
      if (val) this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    }
  },

  methods: {
    async handleContinue () {
      await this.$_loans_updateLead(this.updateLeadPayload, this.dataLayerObject)
      this.$_loans_submitLeadIfReady(true)
    }
  }
}
</script>

<style scoped lang="scss">
.payment-summary {
  &-content {
    @apply flex justify-center mx-auto w-full text-center;
  }

  &__header {
    @apply text-center max-w-600 m-auto mb-40 xs-only:p-[15px];

    &--title {
      @apply max-w-400 text-center m-auto mb-[18px];
    }

    &--subtitle {
      @apply text-base font-semibold;
    }
  }

  &__button {
    @apply w-[280px];
  }

  &__faq {
    @apply max-w-[680px] mt-[120px];
  }
}
</style>
